"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SMS = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function SMS(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2H18C20.2091 2 22 3.79086 22 6V14C22 16.2091 20.2091 18 18 18H8C7.19856 17.9847 6.42433 18.2908 5.85 18.85L2.85 21.85C2.75833 21.9451 2.63212 21.9992 2.5 22C2.22386 22 2 21.7761 2 21.5V6C2 3.79086 3.79086 2 6 2ZM8.5 11C8.77614 11 9 10.7761 9 10.5V9.5C9 9.22386 8.77614 9 8.5 9H7.5C7.22386 9 7 9.22386 7 9.5V10.5C7 10.7761 7.22386 11 7.5 11H8.5ZM13 10.5C13 10.7761 12.7761 11 12.5 11H11.5C11.2239 11 11 10.7761 11 10.5V9.5C11 9.22386 11.2239 9 11.5 9H12.5C12.7761 9 13 9.22386 13 9.5V10.5ZM16.5 11C16.7761 11 17 10.7761 17 10.5V9.5C17 9.22386 16.7761 9 16.5 9H15.5C15.2239 9 15 9.22386 15 9.5V10.5C15 10.7761 15.2239 11 15.5 11H16.5Z",
    fill: "currentColor"
  }));
}

exports.SMS = SMS;